export const DEPENDENT_COVERAGE_VALIDATION_RULES = {
  startDate: {
    isRequiredTrim: {
      value: true,
    },
  },
  endDate: {
    higherThan: {
      value: {
        field: "startDate",
        customMessageKey: "validation.customMessages.endDate",
      },
    },
    lowerThan: {
      value: {
        field: "limitEndDate",
        customMessageKey: "validation.customMessages.coverageStartDate",
      },
    },
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "defineEndDate",
        expectedValues: [true],
      },
    },
  },
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  isInactive: {
    isRequiredBoolean: {
      value: true,
    },
  },
  isInactiveReasonType: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "isInactive",
        expectedValues: ["true"],
      },
    },
  },
  isInactiveOtherReason: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "isInactiveReasonType",
        expectedValues: ["OTHER"],
      },
    },
  },
  isInactiveWithdrawalDate: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "isInactiveReasonType",
        expectedValues: ["WITHDRAWN_YEARLY", "WITHDRAWN_PERMANENT"],
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/coverages/dependentCoverageValidationRules.js